var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('van-overlay',{attrs:{"show":_vm.pending,"z-index":"9999"}},[_c('div',{staticClass:"center"},[_c('van-loading',{attrs:{"color":"#1989fa","vertical":"","size":"24"}},[_vm._v("正在加载数据...")])],1)]),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }